import Http from '../../../helpers/Http'
import { toast } from 'react-toastify'

export const fetchAllProductsFromCollection = async (params, id) => {
    try {
        const { data } = await Http.POST(
            'fetchCollectionById',
            {
                collectionId: id
            },
            params
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}
